import * as Immutable from 'immutable';
import * as React from 'react';
import { Fabric, FabricSize } from '@af-common/UIData/_data/Fabrics';
import FabricSelectContainer from '@af-common/Common/_containers/FabricSelectContainer';
import { Button } from '@mui/material';
import { Trans } from 'react-i18next';
import { Texture, Close } from '@mui/icons-material';
import { batch } from 'react-redux';

export interface Props {
	enabled?: boolean
	onClick?: () => void
	resizeViewer?: (width:number, height:number) => void
	setSize?: (width: number, height: number) => void
	fabrics?: Immutable.OrderedMap<number, Fabric>
	windowWidth?: number,
	viewerHeight?: number,
}

type State = {
	id_fabric: number
	size: string
	fabricLabelWidth: number
	fabricName: string
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class PreviewFabric extends React.Component<Props, State> {
	private onChangeFabric(fabric: Fabric, size: FabricSize) {
		this.props.setSize(size.get('width'), size.get('height'));
	}

	render = () => <div className="preview-fabric-wrapper">
		{ this.props.enabled && 
			<div className="fabric-preview">
				<Button 
					className={'wide'+ (this.props.enabled ? ' active':'')}
					variant="outlined"
					onClick={() => {
						batch(() => {
							this.props.onClick();
							this.props.resizeViewer(this.props.enabled ? this.props.windowWidth - 100 : this.props.windowWidth - 280, this.props.viewerHeight);
						});
					}}
				>
					{!this.props.enabled ? <Texture /> : <Close />}&nbsp;
					{(!this.props.enabled ? <T>Preview Fabric</T> : <T>Exit Preview</T>)}
				</Button>
				<FabricSelectContainer onChange={this.onChangeFabric.bind(this)} displayInfo addGridContainer/>
			</div>
		}
	</div>
}